module.exports = __webpack_public_path__ + "img/psm_logo-inverse.433f59a4.png";